import { TextField } from '@mui/material'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { Controller } from 'react-hook-form'
import { PatternFormat } from 'react-number-format'

const FormInputCnpj = forwardRef(({ name, label, control, errors, ...props }, ref) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <PatternFormat
                    {...field}
                    ref={ref}
                    format='##.###.###/####-##'
                    allowEmptyFormatting
                    mask='_'
                    customInput={TextField}
                    label={label}
                    error={!!errors}
                    helperText={errors?.message}
                    {...props}
                />
            )}
        />
    )
})

FormInputCnpj.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object,
    errors: PropTypes.object
}

FormInputCnpj.displayName = 'FormInputCnpj'

export default FormInputCnpj